import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ContractDTO } from '../../../api/plyca-dtos-v2';
import { RelatedDocumentDTO, TaskDTO, getParentIdentifierFromString, getSimpleIdentifierFromString } from '../../../api/plyca-dtos';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { CertificationDTO } from '../model/certification.model';
import { ProjectOrganizationalSnapshotValidations } from '../../projectOrganizationalSnapshot/component/projectOrganizationalSnapshot.validation';
import { FormConfig } from '../../../components/forms/form.objects';


export class CertificationModel {
  dto: CertificationDTO;
  ui: {
    divisionId?: string,
    dossierId?: string,
    edition?: boolean;
    isModeError?: boolean;
    isREPLYCATask?: boolean,
    isProjectReplyca?: boolean,
    existsRelatedReceipt?: boolean;
    notVisibleRelatedReceipts?: Array<RelatedDocumentDTO>;
    visibleRelatedReceipts?: Array<RelatedDocumentDTO>;
    contractModificationType?: string;
    activeTemporayPeriodOrganizationalChange?: boolean;
    enabledPreviousOrganizationalUnitRegistration?: boolean;
    selectedProjectOrganizationalSnapshot?: any;
  };
}

@Component({
  //templateUrl: '../../baseFormComponent/baseForm.template.html'
  templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html',
  providers: [ProjectOrganizationalSnapshotValidations]
})
export class CertificationComponent extends BaseFormComponent<CertificationDTO, CertificationModel> implements OnInit, OnDestroy {
  private contract: ContractDTO;
  constructor(
    private projectOrganizationalSnapshotValidations: ProjectOrganizationalSnapshotValidations,
    elem: ElementRef) {
    super(elem);
  }

  ngOnInit(): void {
    if (this.task && this.task.work && this.task.work.contract) {
      console.log('INVOCACION DE RECEIPT DESDE TAREA', this.task);
      //this.workRegisterContractModification = this.task.work;
      //this.identifier = this.task.work.registerContractModification.identifier;
      this.contract = this.task.work.contract;
    }
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'certification/certificationSettings.json';
  }
  getServiceURL(): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: CertificationDTO): Observable<CertificationModel> {
    let model = new CertificationModel();

    // TODO
    // ver si WorkCertificaion hay que incluirlo en plyca-dtos.ts
    model.dto = this.task.work['certification'];

    model.ui = {
      edition: true,
      isModeError: false,
      existsRelatedReceipt: false,
      notVisibleRelatedReceipts: new Array<RelatedDocumentDTO>(),
      visibleRelatedReceipts: new Array<RelatedDocumentDTO>(),
      isREPLYCATask: false,
      isProjectReplyca: false,
      contractModificationType: null,
      activeTemporayPeriodOrganizationalChange: false,
      enabledPreviousOrganizationalUnitRegistration: false,
      selectedProjectOrganizationalSnapshot: new Object()
    };

    model.ui.contractModificationType = this.translate.instant('Certification.detail.contractModificationType.value');
    if (this.task && this.task.work) {
      if (this.task.work.context && this.task.work.context.configurations) {
        if (this.task.work.context.configurations['screenMode']) {
          if (this.task.work.context.configurations['screenMode'].value == 'RECTIFICA' || this.task.work.context.configurations['screenMode'].value == 'ANULA') {
            model.ui.isModeError = true;
            if (this.task.work.context.configurations['screenMode'].value == 'ANULA') {
              model.ui.edition = false;
            }
          }
        }
        if (this.task.work.context.configurations['isREPLYCATask'].value == '1') {
          model.ui.isREPLYCATask = true;
        }

        if (this.task.work.context.configurations['isProjectReplyca'].value == '1') {
          model.ui.isProjectReplyca = this.task.work.context.configurations['isProjectReplyca'].value;
        }
      }
      if (model.dto.document && model.dto.document.relatedDocuments) {
        let relatedDocuments = model.dto.document.relatedDocuments;
        for (let i in relatedDocuments) {
          if (relatedDocuments[i]) {
            if (relatedDocuments[i].visible) {
              model.ui.visibleRelatedReceipts.push(relatedDocuments[i]);
            } else {
              model.ui.notVisibleRelatedReceipts.push(relatedDocuments[i]);
            }
          }
        }
      }
      if (model.ui.visibleRelatedReceipts
        && model.ui.visibleRelatedReceipts[0]
        && model.ui.visibleRelatedReceipts[0].document) {
        model.ui.existsRelatedReceipt = true;
      }
    }

    model.ui.divisionId = getSimpleIdentifierFromString(model.dto.division.identifier);
    model.ui.dossierId = this.normalizaDossierId(getParentIdentifierFromString(model.dto.division.identifier));


    if (model.dto?.context && model.dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
      model.ui.activeTemporayPeriodOrganizationalChange = model.dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
      if (model.ui.activeTemporayPeriodOrganizationalChange) {
        model.ui.enabledPreviousOrganizationalUnitRegistration = true;
      } else {
        if (model.dto.previousOrganizationalUnitRegistration !== undefined) {
          //No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
          model.ui.enabledPreviousOrganizationalUnitRegistration = false;
        }
      }
    }
    model.ui.selectedProjectOrganizationalSnapshot = model.dto.projectOrganizationalSnapshot;
    return of(model);
  }
  modelToDTO(model: CertificationModel): CertificationDTO {
    return model.dto;
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Certification.detail.title';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    //formConfig.showValidations = true;
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
    /*formConfig.functions.push({
      identifier: 'isVacio',
      fn: this.isVacio.bind(this)
    });
    formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.loadOrganizationalSnapshotData
    });
    formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.changeProjectOrganizationalSnapshot
    });
    return of(formConfig);*/
  }

  protected updateTask(updatedTask: TaskDTO) {
    this.formService.merge(this.task, updatedTask);
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.processTask();
      });
    this.headerActionsService.addDivider();
    this.addBackAction();
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');
    _formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.projectOrganizationalSnapshotValidations.loadOrganizationalSnapshotData
    });
    _formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.projectOrganizationalSnapshotValidations.changeProjectOrganizationalSnapshot
    });
    _formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.projectOrganizationalSnapshotValidations.visiblePreviousOrganizationalUnitRegistration
    });


  }

}